import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../styles/header-top.scss";

const UserCircleIcon = ({ size = 44 }) => (
  <svg
    className="header-user-icon__svg"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    aria-hidden="true"
    focusable="false"
  >
    {/* Outer circle */}
    <circle
      cx="32"
      cy="32"
      r="27"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
    />
    {/* Head */}
    <circle cx="32" cy="26" r="9" fill="currentColor" />
    {/* Shoulders */}
    <path
      d="M16 51c3.5-9 12-14 16-14s12.5 5 16 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
    />
  </svg>
);

const HeaderThree = () => {
  const [active, setActive] = useState(false);
  const [scroll, setScroll] = useState(false);

  const careerBaseStyle = { textTransform: "none" };
  const careerActiveStyle = { ...careerBaseStyle, color: "#e91078" };
  const careerStyle = ({ isActive }) =>
    isActive ? careerActiveStyle : careerBaseStyle;

  useEffect(() => {
    const offCanvasNav = document.getElementById("offcanvas-navigation");
    if (!offCanvasNav) return;

    // Add a toggle to each LI that has a direct child .sub-menu
    const parents = offCanvasNav.querySelectorAll("li.menu-item-has-children");
    parents.forEach((li) => {
      const ul = li.querySelector(":scope > ul.sub-menu");
      if (!ul) return;

      // Collapse by default
      ul.style.display = "none";

      // Insert the toggle once, right before the UL
      let toggle = li.querySelector(":scope > .mean-expand-class");
      if (!toggle) {
        toggle = document.createElement("span");
        toggle.className = "mean-expand-class";
        toggle.setAttribute("role", "button");
        toggle.setAttribute("tabindex", "0");
        toggle.setAttribute("aria-expanded", "false");
        toggle.textContent = "+";
        li.insertBefore(toggle, ul);
      }
    });

    const setToggleState = (toggleEl, expanded) => {
      if (!toggleEl) return;
      toggleEl.textContent = expanded ? "−" : "+";
      toggleEl.setAttribute("aria-expanded", expanded ? "true" : "false");
    };

    const closeBranch = (li) => {
      li.classList.remove("active");
      const ul = li.querySelector(":scope > .sub-menu");
      if (ul) ul.style.display = "none";
      setToggleState(li.querySelector(":scope > .mean-expand-class"), false);
    };

    const openBranch = (li) => {
      li.classList.add("active");
      const ul = li.querySelector(":scope > .sub-menu");
      if (ul) ul.style.display = "block";
      setToggleState(li.querySelector(":scope > .mean-expand-class"), true);
    };

    function onToggleClick(e) {
      e.preventDefault();
      e.stopPropagation();
      const li = this.parentElement;
      const isOpening = !li.classList.contains("active");

      // Close siblings at same depth
      const siblings = li.parentElement.querySelectorAll(":scope > li.active");
      siblings.forEach((sib) => {
        if (sib !== li) closeBranch(sib);
      });

      if (isOpening) openBranch(li);
      else closeBranch(li);
    }

    function onToggleKeydown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onToggleClick.call(this, e);
      }
    }

    const toggles = offCanvasNav.querySelectorAll(".mean-expand-class");
    toggles.forEach((t) => {
      t.addEventListener("click", onToggleClick);
      t.addEventListener("keydown", onToggleKeydown);
    });

    // Sticky header
    const onScroll = () => setScroll(window.pageYOffset > 250);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      toggles.forEach((t) => {
        t.removeEventListener("click", onToggleClick);
        t.removeEventListener("keydown", onToggleKeydown);
      });
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const mobileMenu = () => setActive(!active);

  const productsMenu = (
    <>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Kiubunifu Academy
        </NavLink>
      </li>
    </>
  );

  const servicesMenu = (
    <>
      <li className="menu-item-has-children">
        <Link to="#">IT Enabled Services (ITES)</Link>
        <ul className="sub-menu">
          <li className="menu-item-has-children">
            <Link to="#">Business Process Outsourcing (BPO)</Link>
            <ul className="sub-menu">
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Customer Support and Call Center
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Finance and Accounting Services
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  IT and Software Operations
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Supply Chain Optimization
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Talent and Human Resources (HR) Services
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Tele-sales and Tele-marketing
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Social Media Marketing and Management
                </NavLink>
              </li>
            </ul>
          </li>

          <li className="menu-item-has-children">
            <Link to="#">Knowledge Process Outsourcing (KPO)</Link>
            <ul className="sub-menu">
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Research and Development (R&amp;D)
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Legal Documentation, Research
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Financial and Investment Research
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Market/Business Research (including data mining)
                </NavLink>
              </li>
              <li>
                <NavLink to="#" style={careerBaseStyle}>
                  Data Analytics and Data Science
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <li className="menu-item-has-children">
        <Link to="#">Consulting Services</Link>
        <ul className="sub-menu">
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Digital Transformation
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Impact Investing and Management
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Organisation Due Diligence
            </NavLink>
          </li>

          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Fund Management
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Project Design and Management
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Business and Organisation Strengthening
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Supply Chain and Operations
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Aid Effectiveness
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Strategy, Learning and Evaluation
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Third Party Monitoring
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Business Transformation
            </NavLink>
          </li>
          <li>
            <NavLink to="#" style={careerBaseStyle}>
              Growth, Marketing and Sales
            </NavLink>
          </li>
        </ul>
      </li>
    </>
  );

  const industriesMenu = (
    <>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Energy and Nature Resources
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Social and Public Sector / Government
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Non-Governmental and Nonprofit
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Financial Services Industry, Capital Markets, Banking and Insurance
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Health Care and Life Sciences
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Climate Change and Environment
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Technology, Media and Telecommunications
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          HealthCare Systems, Policies and Service Delivery
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Food Security and Agriculture
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Travel, Logistics and Infrastructure
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Hospitality, Tourism and Leisure
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Manufacturing
        </NavLink>
      </li>
      <li>
        <NavLink to="#" style={careerBaseStyle}>
          Automotive
        </NavLink>
      </li>
    </>
  );

  const companyMenu = (
    <>
      <li>
        <Link to="/about">About Us</Link>
      </li>
      <li>
        <Link to="#">The Team</Link>
      </li>
      <li className="menu-item-has-children">
        <Link to="#">Careers</Link>
        <ul className="sub-menu">
          <li>
            <NavLink to="/graduate-training" style={careerStyle}>
              Call for Graduate Associates
            </NavLink>
          </li>
          <li>
            <NavLink to="/internship" style={careerStyle}>
              Call for Interns
            </NavLink>
          </li>
        </ul>
      </li>
    </>
  );

  return (
    <>
      {/*==============================
      Mobile Menu
      ============================== */}
      <div className={`mobile-menu-wrapper ${active ? "body-visible" : ""}`}>
        <div className="mobile-menu-area">
          <div className="mobile-logo">
            <Link to="/">
              <img src="assets/img/logo-kiu.png" alt="Bizmaster" />
            </Link>
            <button className="menu-toggle" onClick={mobileMenu}>
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="mobile-menu">
            <ul id="offcanvas-navigation">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <Link to="/how-it-works">How it Works</Link>
              </li>

              <li className="menu-item-has-children menu-products">
                <Link to="#">Products</Link>
                <ul className="sub-menu">{productsMenu}</ul>
              </li>

              <li className="menu-item-has-children menu-expertise">
                <Link to="#">Services</Link>
                <ul className="sub-menu">{servicesMenu}</ul>
              </li>

              <li className="menu-item-has-children menu-industries">
                <Link to="#">Industries</Link>
                <ul className="sub-menu">{industriesMenu}</ul>
              </li>

              <li className="menu-item-has-children menu-company">
                <Link to="#">Company</Link>
                <ul className="sub-menu">{companyMenu}</ul>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Header Area */}
      <header className="nav-header header-layout3 theme-violet">
        <div className={`sticky-wrapper ${scroll ? "sticky" : ""}`}>
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-auto">
                <div className="header-logo">
                  <Link to="/">
                    <img src="assets/img/logo-kiu.png" alt="logo" />
                  </Link>
                </div>
              </div>

              <div className="col-auto">
                {/* Desktop Main Menu */}
                <nav className="main-menu d-none d-lg-inline-block">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>

                    <li>
                      <Link to="/how-it-works">How it Works</Link>
                    </li>

                    <li className="menu-item-has-children menu-products">
                      <Link to="#">Products</Link>
                      <ul className="sub-menu">{productsMenu}</ul>
                    </li>

                    <li className="menu-item-has-children menu-expertise">
                      <Link to="#">Services</Link>
                      <ul className="sub-menu">{servicesMenu}</ul>
                    </li>

                    <li className="menu-item-has-children menu-industries">
                      <Link to="#">Industries</Link>
                      <ul className="sub-menu">{industriesMenu}</ul>
                    </li>

                    <li className="menu-item-has-children menu-company">
                      <Link to="#">Company</Link>
                      <ul className="sub-menu">{companyMenu}</ul>
                    </li>
                  </ul>
                </nav>

                {/* Mobile toggler */}
                <div className="navbar-right d-inline-flex d-lg-none">
                  <button
                    type="button"
                    className="menu-toggle icon-btn"
                    onClick={mobileMenu}
                  >
                    <i className="fas fa-bars" />
                  </button>
                </div>
              </div>

              {/* Contact block between menu and user icon (desktop only) */}
              <div className="col-auto d-none d-lg-block">
                <div className="header-contact">
                  <span className="header-contact-label">Contact Us</span>
                  <a href="tel:+256393162767" className="header-contact-phone">
                    +256-393-162-767
                  </a>
                </div>
              </div>

              {/* User icon */}
              <div className="col-auto ms-xxl-4 d-xl-block d-none">
                <div className="header-user-icon">
                  <a
                    href="https://system.kiubunifu.com"
                    className="header-user-icon__btn"
                    aria-label="Go to System"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <UserCircleIcon size={44} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderThree;